import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { SignInfoService } from 'services/sign-info/sign-info.service';

import { Helper } from 'libraries/Helper';
import { SignMessRequestsBo } from 'bll/SignMessRequestsBo';
import { SignMessRequestsService } from 'services/signMessRequests/sign-mess-requests.service';
import { AppError } from 'app/common/app-error';
import { BadInput } from 'app/common/bad-input';
import { AuthService } from 'services/auth/auth.service';
import { SignInfo } from 'domain-models/SignInfo';
import { UserIdleService } from 'services/user-idle/user-idle.service';

// import { Socket } from 'ng-socket-io';
import { Observable } from '../../../../node_modules/rxjs/Observable';
import { WeightStationService } from 'services/weight-station/weight-station.service';
import { environment } from 'environments/environment';
import { ConfirmationService } from 'primeng/primeng';
@Component({
	selector: 'app-display-section',
	templateUrl: './display-section.component.html',
	styleUrls: ['./display-section.component.css']
})
export class DisplaySectionComponent implements OnInit {
	weighStationTypeId = environment.deviceTypeNameIds.weighStation;
	signs = new Array<SignInfo>();
	loading: boolean = false;
	groupName: string;
	userSignsControl: number[];
	refreshTimer;

	selectedSigns = {};

	selectAll: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private signInfoService: SignInfoService,
		private signMessRequestsService: SignMessRequestsService,
		private authService: AuthService,
		private userIdleService: UserIdleService,
		private weightStationService: WeightStationService // private socket: Socket
	) {}

	ngOnInit() {
		this.groupName = this.route.params['signGroupName'];
		this.onRefreshContent();
		this.subscribeToRouteChange();
		this.refreshTimer = setInterval(this.onRefreshContent.bind(this), 10000);
		//console.log("oninit");

		this.getSocketEvent().subscribe((msg) => {
			//console.log('socket data :', msg);
			var id: any = (msg as any).id;
			//console.log("pre", this.signs);
			this.signInfoService
				.getByValues(['view/username', 'id'], [this.authService.currentUser.username, id])
				.subscribe((result) => {
					//this.signs = result;
					//console.log('signs', this.signs);
					var index = this.signs.map((s) => s.Id).indexOf(id);
					//console.log("this is index", index);

					this.signs[index] = result[0];
				});
		});
		// this.socket.on("chat message", (msg) => {
		//   console.log(msg);
		//   this.signInfoService.getByValues(['view/username', 'id'], [this.authService.currentUser.username, msg]).subscribe(result => {
		//     //this.signs = result;
		//     console.log('signs', this.signs);
		//     var index = this.signs.findIndex(sign => sign.Id = msg);
		//     console.log("this is index", index);

		//     this.signs[index] = result[0];
		//   });
		// })
	}

	subscribeToRouteChange() {
		this.route.params.subscribe((params: Params) => {
			this.groupName = params['signGroupName'];
			this.selectedSigns = {}; //Adding this to clear selection when you switch groups
			this.signInfoService
				.getByValues(
					['view/groupName', 'username'],
					[this.groupName, this.authService.currentUser.username]
				)
				.subscribe((result) => {
					this.signs = result;
					// console.log('signs', this.signs);
					// console.log(1);
					this.signInfoService
						.getByValues(['control/username'], [this.authService.currentUser.username])
						.subscribe((result) => {
							this.userSignsControl = result;
							// console.log('signs control', this.userSignsControl);
							this.loading = false;
							// console.log(2)
						});
				});
		});
	}

	getSocketEvent() {
		let observable = new Observable((observer) => {
			// comenting until we have a socket server
			// this.socket.on('update-sign', (data) => {
			//   observer.next(data);
			// });
			return () => {
				// comenting until we have a socket server
				// this.socket.disconnect();
			};
		});
		return observable;
	}

	sendMessage(msg: string) {
		//commented until we have our socket server
		// this.socket.emit("chat message", msg);
	}

	getMessage() {
		//commented until we have our socket server
		// return this.socket
		//   .fromEvent("chat message")
		//   .map(data => (data as any).msg);
	}

	ngOnDestroy() {
		console.info('Cleared Refresh Timer');
		clearInterval(this.refreshTimer);
	}

	async onControl(event: Event) {
		this.authService.updateLogStatus();

		let canWrite = await this.authService.checkWriteAccess();
		if (!canWrite) {
			return;
		}

		console.info('Controlling');
		//TODO This lines need a refactor to a method
		const selectedSigns = this.signs.filter((s) => this.selectedSigns[s.Id] == true);
		let deviceTypeIds = selectedSigns.map((t) => t.DeviceTypeNameId);
		let set = new Set(deviceTypeIds);
		if (set.size > 1) {
			if (set.has(this.weighStationTypeId)) {
				Helper.alert('You have selected incompatible sign types to control', 3);
				return;
			}
		}
		const queryParams = { ids: selectedSigns.map((s) => s.Id), redirectGroup: this.groupName };
		if (set.has(this.weighStationTypeId)) {
			this.router.navigate(['/weigh-station'], { queryParams });
		} else {
			this.router.navigate(['/control'], { queryParams });
		}
		// Store command in DB
	}

	async onClear(event: Event) {
		this.authService.updateLogStatus();

		let canWrite = await this.authService.checkWriteAccess();
		if (!canWrite) {
			return;
		}

		console.info('Clearing');
		//TODO This lines need a refactor to a method
		let selectedSigns = this.signs.filter((s) => this.selectedSigns[s.Id] == true);
		let deviceTypeIds = selectedSigns.map((t) => t.DeviceTypeNameId);
		let set = new Set(deviceTypeIds);
		if (set.size > 1) {
			if (set.has(this.weighStationTypeId)) {
				Helper.alert('You have selected incompatible sign types to control', 3);
				return;
			}
		}
		if (set.has(this.weighStationTypeId)) {
			this.weightStationService
				.postMessage(
					this.signs.filter((s) => this.selectedSigns[s.Id] == true).map((sI) => sI.Id) as any,
					''
				)
				.subscribe(() => {
					this.onRefreshContent();
				});
		} else {
			// Store command in DB
			this.signs
				.filter((s) => this.selectedSigns[s.Id] == true)
				.map((s) => {
					let signMessRequest = SignMessRequestsBo.CreateClearRequest(
						s.Id,
						this.authService.currentUser.username
					);
					this.signMessRequestsService.create(signMessRequest).subscribe(
						(id) => {
							console.log('The id of the just added thing is', id);
							this.onRefreshContent();
						},
						(error: AppError) => {
							if (error instanceof BadInput) alert('Bad input error.');
							else throw error;
						}
					);
				});
		}
	}

	async onCurrent(event: Event) {
		this.authService.updateLogStatus();

		if (!this.authService.readAccess) {
			return;
		}
		//TODO This lines need a refactor to a method
		let selectedSigns = this.signs.filter((s) => this.selectedSigns[s.Id] == true);
		let deviceTypeIds = selectedSigns.map((t) => t.DeviceTypeNameId);
		let set = new Set(deviceTypeIds);
		if (set.size > 1) {
			if (set.has(this.weighStationTypeId)) {
				Helper.alert('You have selected incompatible sign types to control', 3);
				return;
			}
		}
		if (set.has(this.weighStationTypeId)) {
			this.weightStationService
				.currentMessage(
					this.signs.filter((s) => this.selectedSigns[s.Id] == true).map((sI) => sI.Id) as any
				)
				.subscribe(() => {
					this.onRefreshContent();
				});
		} else {
			console.info('Retrieving Current');
			// Retrieve from DB
			this.signs
				.filter((s) => this.selectedSigns[s.Id] == true)
				.map((s) => {
					let signMessRequest = SignMessRequestsBo.CreatePollRequest(
						s.Id,
						this.authService.currentUser.username
					);
					this.signMessRequestsService.create(signMessRequest).subscribe(
						(id) => {
							console.log('The id of the just polled thing is', id);
							this.onRefreshContent();
						},
						(error: AppError) => {
							if (error instanceof BadInput) alert('Bad input error.');
							else throw error;
						}
					);
				});
		}
	}

	onToggleSelectAll(event: Event) {
		// this.authService.updateLogStatus();
		// if (!this.authService.writeAccess) {
		// 	this.authService.logout();
		// }

		this.selectAll = !this.selectAll;
		console.info('Selecting/Deselecting All');
		if (!this.selectAll) {
			this.selectedSigns = {};
		} else {
			//var selectOrDeselect = this.signs.length > this.signs.filter(s => this.selectedSigns[s.Id] == true).length;
			for (let i = 0; i < this.signs.length; i++) {
				// ? Weigh Stations use different statuses,
				// ? so here we just bypass the status check for weigh stations
				if (
					this.signs[i].SignCanControl &&
					(this.signs[i].Status == 'Online' ||
						this.signs[i].DeviceTypeNameId == environment.deviceTypeNameIds.weighStation)
				) {
					this.selectedSigns[this.signs[i].Id] = this.selectAll;
				}
			}
		}
	}

	onRefreshContent() {
		// Helper.alert("Refreshing Content",1,"top", "right", "ti-clock",500);
		console.info('Refresh Content Called');
		if (!this.userIdleService.waitingAuth) {
			// if (true) {
			this.authService.updateLogStatus();
			if (!this.authService.getTokenExpiration('readToken')) {
				this.authService.logout();
			}

			this.loading = true;
			//setTimeout(() => this.loading = false, 1000);

			this.groupName = this.route.snapshot.params['signGroupName'];
			this.signInfoService
				.getByValues(
					['view/groupName', 'username'],
					[this.groupName, this.authService.currentUser.username]
				)
				.subscribe((result) => {
					this.signs = result;
					// console.log('signs', this.signs);
					this.signInfoService
						.getByValues(['control/username'], [this.authService.currentUser.username])
						.subscribe((result) => {
							this.userSignsControl = result;
							// console.log('signs control', this.userSignsControl);
							this.loading = false;
						});
				});

			// this.route.params.subscribe(
			//   (params: Params) => {
			//     this.groupName = params['signGroupName'];
			//     this.signInfoService.getByValues(['view/groupName', 'username'], [this.groupName, this.authService.currentUser.username]).subscribe(result => {
			//       this.signs = result;
			//       // console.log('signs', this.signs);
			//       console.log(1);
			//       this.signInfoService.getByValues(['control/username'], [this.authService.currentUser.username]).subscribe(result => {
			//         this.userSignsControl = result;
			//         // console.log('signs control', this.userSignsControl);
			//         this.loading = false;
			//         console.log(2)
			//       });
			//     });
			//   }
			// );

			// this.route.params.subscribe(
			//   (params: Params) => {
			//     this.signInfoService.getByValues(['control/username'], [this.authService.currentUser.username]).subscribe(result => {
			//       this.userSignsControl = result;
			//       console.log('signs control', this.userSignsControl);
			//     });
			//   }
			// );
		}
	}

	signClicked(event) {
		this.selectedSigns[event.id] = event.isSelected;

		if (event.isSelected == false) {
			delete this.selectedSigns[event.id];
		}
	}

	trackByMessage(index, sign: SignInfo) {
		return sign.Id + sign.CurrentMessage;
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/display/display-section/display-section.component.ts